/* Whiskerly template — header, drawers and AJAX cart. Vanilla JS, no deps.
   Every wk- section includes this file, so it guards against running twice. */
(function () {
  "use strict";
  if (window.WK) return;

  var routes = window.wkRoutes || { root: "/", cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change", cartUpdate: "/cart/update" };
  var DRAWER_SECTION = "wk-cart-drawer";

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Drawers (menu + cart) ---------------- */
  var lastFocus = null;

  function openDrawer(name) {
    var d = $('[data-wk-drawer="' + name + '"]');
    if (!d) return false;
    $$("[data-wk-drawer].is-open").forEach(function (o) { if (o !== d) closeDrawer(o); });
    lastFocus = document.activeElement;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("wk-lock");
    var panel = $(".wk-drawer__panel", d);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
    if (name === "menu") $$("[data-wk-menu-open]").forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
    return true;
  }

  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    if (!$("[data-wk-drawer].is-open")) document.documentElement.classList.remove("wk-lock");
    if (d.getAttribute("data-wk-drawer") === "menu") $$("[data-wk-menu-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function trapFocus(e) {
    var d = $("[data-wk-drawer].is-open");
    if (!d || e.key !== "Tab") return;
    var f = $$('a[href],button:not([disabled]),input:not([type="hidden"]),textarea,select,summary', d).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------- Cart rendering ---------------- */
  function cartSections() {
    var ids = [];
    if ($("[data-wk-cart-drawer-body]")) ids.push(DRAWER_SECTION);
    var page = $("[data-wk-cart-page]");
    if (page) ids.push(page.getAttribute("data-section-id"));
    return ids;
  }

  function extractRoot(html) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, "text/html");
    return $("[data-wk-cart-root]", doc);
  }

  function updateCount(count) {
    $$("[data-wk-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
      el.classList.remove("is-bump");
      void el.offsetWidth;
      if (count) el.classList.add("is-bump");
    });
    $$("[data-wk-cart-open]").forEach(function (el) { el.setAttribute("aria-label", "Cart (" + count + ")"); });
  }

  function renderSections(sections) {
    if (!sections) return;
    var count = null;
    var drawerBody = $("[data-wk-cart-drawer-body]");
    if (drawerBody && sections[DRAWER_SECTION]) {
      var root = extractRoot(sections[DRAWER_SECTION]);
      var current = $("[data-wk-cart-root]", drawerBody);
      if (root) {
        var scroll = $(".wk-cart__main", drawerBody);
        var top = scroll ? scroll.scrollTop : 0;
        current ? current.replaceWith(root) : drawerBody.appendChild(root);
        var newScroll = $(".wk-cart__main", drawerBody);
        if (newScroll) newScroll.scrollTop = top;
        count = parseInt(root.getAttribute("data-count"), 10) || 0;
      }
    }
    var page = $("[data-wk-cart-page]");
    if (page) {
      var pageRoot = extractRoot(sections[page.getAttribute("data-section-id")]);
      if (pageRoot) {
        var cur = $("[data-wk-cart-root]", page);
        cur ? cur.replaceWith(pageRoot) : page.appendChild(pageRoot);
        count = parseInt(pageRoot.getAttribute("data-count"), 10) || 0;
      }
    }
    if (count !== null) updateCount(count);
  }

  function showCartError(msg) {
    $$("[data-wk-cart-error]").forEach(function (el) {
      el.textContent = msg;
      el.hidden = false;
      setTimeout(function () { el.hidden = true; }, 5000);
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw new Error(data.description || data.message || "Something went wrong");
        return data;
      });
    });
  }

  function refreshCart() {
    var ids = cartSections();
    if (!ids.length) return Promise.resolve();
    return fetch(routes.root + "?sections=" + ids.join(","))
      .then(function (r) { return r.json(); })
      .then(renderSections)
      .catch(function () {});
  }

  function openCart() {
    if (!openDrawer("cart")) {
      if (!$("[data-wk-cart-page]")) window.location.href = routes.cart;
    }
  }

  function withSections(body) {
    var ids = cartSections();
    if (ids.length) {
      body.sections = ids.join(",");
      body.sections_url = window.location.pathname;
    }
    return body;
  }

  function changeLine(key, qty) {
    var line = $('[data-wk-line="' + CSS.escape(key) + '"]');
    if (line) line.classList.add("is-updating");
    return postJSON(routes.cartChange + ".js", withSections({ id: key, quantity: Math.max(0, qty) }))
      .then(function (cart) { renderSections(cart.sections); publishDawn(cart); })
      .catch(function (err) {
        if (line) line.classList.remove("is-updating");
        showCartError(err.message);
        refreshCart();
      });
  }

  function addItems(items, button) {
    if (button) button.classList.add("is-loading");
    return postJSON(routes.cartAdd + ".js", withSections({ items: items }))
      .then(function (res) {
        if (res.sections) renderSections(res.sections);
        else refreshCart();
        publishDawn(res);
        if (button) {
          button.classList.remove("is-loading");
          button.classList.add("is-added");
          setTimeout(function () { button.classList.remove("is-added"); }, 1400);
        }
        document.dispatchEvent(new CustomEvent("wk:cart:updated"));
        openCart();
        return res;
      })
      .catch(function (err) {
        if (button) button.classList.remove("is-loading");
        throw err;
      });
  }

  function publishDawn(data) {
    if (typeof window.publish === "function" && window.PUB_SUB_EVENTS) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "wk-cart", cartData: data }); } catch (e) {}
    }
  }

  /* ---------------- Discount codes (cart) ---------------- */
  function codeMessage(text, isError) {
    $$("[data-wk-code-msg]").forEach(function (el) {
      el.textContent = text;
      el.classList.toggle("is-error", !!isError);
    });
  }

  function applyCode(code) {
    return postJSON(routes.cartUpdate + ".js", withSections({ discount: code }))
      .then(function (cart) {
        renderSections(cart.sections);
        if (!code) return;
        var match = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
        if (match && match.applicable) codeMessage("Code " + match.code + " applied.");
        else codeMessage("Code " + code + " can't be used on this cart — it may have expired, or you already have a better discount.", true);
      })
      .catch(function (err) { codeMessage(err.message, true); });
  }

  /* ---------------- Predictive search ---------------- */
  var searchTimer, searchController;

  function runSearch(input) {
    var box = $("[data-wk-predictive]", input.closest("[data-wk-search]"));
    if (!box) return;
    var q = input.value.trim();
    if (q.length < 2) { box.hidden = true; box.innerHTML = ""; return; }
    if (searchController) searchController.abort();
    searchController = "AbortController" in window ? new AbortController() : null;
    var url = routes.root + "search/suggest?q=" + encodeURIComponent(q) +
      "&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=wk-predictive-search";
    fetch(url, searchController ? { signal: searchController.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var results = $("[data-wk-predictive-results]", doc);
        box.innerHTML = results ? results.innerHTML : "";
        box.hidden = !box.innerHTML.trim();
      })
      .catch(function () {});
  }

  function initSearch() {
    document.addEventListener("input", function (e) {
      if (!e.target.matches("[data-wk-search-input]")) return;
      clearTimeout(searchTimer);
      var input = e.target;
      searchTimer = setTimeout(function () { runSearch(input); }, 220);
    });
  }

  /* ---------------- Carousel autoplay ---------------- */
  function initCarousels(root) {
    $$("[data-wk-scroller][data-autoplay]", root).forEach(function (track) {
      var secs = parseInt(track.getAttribute("data-autoplay"), 10);
      if (!secs || track._wkAuto || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var paused = false;
      ["mouseenter", "focusin", "touchstart"].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ["mouseleave", "focusout"].forEach(function (ev) { track.addEventListener(ev, function () { paused = false; }); });
      track._wkAuto = setInterval(function () {
        if (paused || document.hidden) return;
        var card = track.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: "smooth" });
      }, secs * 1000);
    });
  }

  /* ---------------- Touch devices: swap card photo without :hover ---------------- */
  function initCardSwap(root) {
    if (!window.matchMedia("(hover: none)").matches) return;
    var cards = $$(".wk-card__media--swap", root);
    if (!cards.length || !window.IntersectionObserver) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var media = entry.target;
        if (entry.isIntersecting) {
          if (media._wkSwap) return;
          media._wkSwap = setInterval(function () {
            media.classList.toggle("wk-card__media--alt-visible");
          }, 2200);
        } else if (media._wkSwap) {
          clearInterval(media._wkSwap);
          media._wkSwap = null;
          media.classList.remove("wk-card__media--alt-visible");
        }
      });
    }, { threshold: 0.4 });
    cards.forEach(function (media) { io.observe(media); });
  }

  /* ---------------- Campaign countdowns ---------------- */
  function pad(n) { return (n < 10 ? "0" : "") + n; }

  function tickTimers() {
    var now = Date.now();
    $$("[data-wk-campaign]").forEach(function (c) {
      var start = Date.parse(c.getAttribute("data-start"));
      var end = Date.parse(c.getAttribute("data-end"));
      var mode = c.getAttribute("data-mode");
      var over = mode === "active" ? now > end : now >= start || now > end;
      if (over && !c.hidden) {
        c.hidden = true;
        var bar = c.closest(".wk-announce--campaign");
        if (bar) { bar.hidden = true; document.documentElement.style.setProperty("--wk-announce-h", "0px"); }
      }
    });
    $$("[data-wk-timer]").forEach(function (el) {
      var diff = Math.floor((Date.parse(el.getAttribute("data-target")) - now) / 1000);
      if (isNaN(diff) || diff < 0) diff = 0;
      var d = Math.floor(diff / 86400);
      var txt = pad(Math.floor((diff % 86400) / 3600)) + ":" + pad(Math.floor((diff % 3600) / 60)) + ":" + pad(diff % 60);
      el.textContent = (d ? d + "d " : "") + txt;
    });
  }

  /* ---------------- Event delegation ---------------- */
  document.addEventListener("click", function (e) {
    var t = e.target;

    var cartOpen = t.closest("[data-wk-cart-open]");
    if (cartOpen && $("[data-wk-drawer='cart']")) {
      e.preventDefault();
      openDrawer("cart");
      refreshCart();
      return;
    }
    if (t.closest("[data-wk-menu-open]")) { openDrawer("menu"); return; }
    if (t.closest("[data-wk-drawer-close]") || t.closest("[data-wk-cart-close]")) {
      closeDrawer(t.closest("[data-wk-drawer]"));
      return;
    }

    var searchToggle = t.closest("[data-wk-search-toggle]");
    if (searchToggle) {
      var header = searchToggle.closest("[data-wk-header]");
      var bar = header && $("[data-wk-search]", header);
      if (bar) {
        bar.hidden = !bar.hidden;
        $$("[data-wk-search-toggle]", header).forEach(function (b) { b.setAttribute("aria-expanded", String(!bar.hidden)); });
        if (!bar.hidden) $("input[type=search]", bar).focus();
      }
      return;
    }

    var codeBtn = t.closest("[data-wk-code-apply]");
    if (codeBtn) {
      var input = $("[data-wk-code-input]", codeBtn.closest("[data-wk-code]"));
      var code = (input.value || "").trim();
      if (!code) { codeMessage("Enter a discount code.", true); return; }
      codeBtn.classList.add("is-loading");
      applyCode(code);
      return;
    }
    if (t.closest("[data-wk-code-remove]")) {
      applyCode("").then(function () { codeMessage("Code removed."); });
      return;
    }

    var qtyBtn = t.closest("[data-wk-qty]");
    if (qtyBtn) {
      changeLine(qtyBtn.getAttribute("data-key"), parseInt(qtyBtn.getAttribute("data-qty"), 10));
      return;
    }

    var swap = t.closest("[data-wk-swap]");
    if (swap) {
      var updates = {};
      (swap.getAttribute("data-remove") || "").split(",").forEach(function (pair) {
        if (!pair) return;
        var i = pair.lastIndexOf(":");
        updates[pair.slice(0, i)] = parseInt(pair.slice(i + 1), 10);
      });
      swap.classList.add("is-loading");
      postJSON(routes.cartUpdate + ".js", { updates: updates })
        .then(function () {
          var props = {};
          var appInput = $('input[name="properties[_app_bonus]"]');
          if (appInput) props._app_bonus = appInput.value;
          return addItems([{ id: parseInt(swap.getAttribute("data-add"), 10), quantity: 1, properties: props }]);
        })
        .catch(function (err) { showCartError(err.message); refreshCart(); });
      return;
    }

    var scrollBtn = t.closest("[data-wk-scroll]");
    if (scrollBtn) {
      var track = $("[data-wk-scroller]", scrollBtn.closest(".wk-section"));
      if (track) track.scrollBy({ left: parseInt(scrollBtn.getAttribute("data-wk-scroll"), 10) * track.clientWidth * 0.8, behavior: "smooth" });
    }
  });

  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t.matches("[data-wk-qty-input]")) {
      changeLine(t.getAttribute("data-key"), parseInt(t.value, 10) || 0);
      return;
    }
    var form = t.closest("[data-wk-add-form]");
    if (form && t.name === "id") {
      var opt = t.tagName === "SELECT" ? t.options[t.selectedIndex] : t;
      var price = opt && opt.getAttribute("data-price");
      var card = form.closest(".wk-card");
      var priceEl = card && $("[data-wk-card-price] b", card);
      if (price && priceEl) priceEl.textContent = price;
    }
  });

  var noteTimer;
  document.addEventListener("input", function (e) {
    if (!e.target.matches("[data-wk-note]")) return;
    clearTimeout(noteTimer);
    var val = e.target.value;
    noteTimer = setTimeout(function () { postJSON(routes.cartUpdate + ".js", { note: val }).catch(function () {}); }, 500);
  });

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-wk-add-form]");
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var item = { id: parseInt(fd.get("id"), 10), quantity: parseInt(fd.get("quantity"), 10) || 1, properties: {} };
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) item.properties[m[1]] = v;
    });
    var btn = form.querySelector('[type="submit"]');
    var errEl = form.querySelector(".wk-form-error");
    if (errEl) errEl.remove();
    addItems([item], btn).catch(function (err) {
      var p = document.createElement("p");
      p.className = "wk-form-error";
      p.setAttribute("role", "alert");
      p.textContent = err.message;
      form.appendChild(p);
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.matches("[data-wk-code-input]")) {
      e.preventDefault();
      var btn = $("[data-wk-code-apply]", e.target.closest("[data-wk-code]"));
      if (btn) btn.click();
      return;
    }
    if (e.key === "Escape") {
      var open = $("[data-wk-drawer].is-open");
      if (open) closeDrawer(open);
      $$("[data-wk-search]").forEach(function (b) { b.hidden = true; });
      $$("[data-wk-predictive]").forEach(function (b) { b.hidden = true; });
    }
    trapFocus(e);
  });

  /* Product CRO section and other scripts can trigger the drawer. */
  document.addEventListener("cart:open", function () { refreshCart().then(openCart); });
  document.addEventListener("wk:cart:added", refreshCart);

  /* ---------------- Header behaviors ---------------- */
  function initHeader(root) {
    var header = $("[data-wk-header]", root);
    if (!header || header._wkInit) return;
    header._wkInit = true;

    var announce = $("[data-wk-announce]", header);
    if (announce) {
      var setH = function () { document.documentElement.style.setProperty("--wk-announce-h", announce.offsetHeight + "px"); };
      setH();
      window.addEventListener("resize", setH);
      var items = $$(".wk-announce__item", announce);
      if (items.length > 1 && !announce._wkTimer) {
        var i = 0;
        var speed = (parseInt(announce.getAttribute("data-speed"), 10) || 5) * 1000;
        announce._wkTimer = setInterval(function () {
          if (announce.matches(":hover")) return;
          items[i].classList.remove("is-active");
          i = (i + 1) % items.length;
          items[i].classList.add("is-active");
        }, speed);
      }
    } else {
      document.documentElement.style.setProperty("--wk-announce-h", "0px");
    }

    var onScroll = function () { header.classList.toggle("is-scrolled", window.scrollY > 8); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Dawn bridge ----------------
     Dawn's product-form.js looks for <cart-drawer> and calls these methods.
     We only define the element when the theme's own drawer script isn't loaded. */
  function defineBridge() {
    if (!window.customElements || customElements.get("cart-drawer") || !$("cart-drawer.wk-dawn-bridge")) return;
    customElements.define("cart-drawer", class extends HTMLElement {
      getSectionsToRender() { return cartSections().map(function (id) { return { id: id }; }); }
      setActiveElement(el) { lastFocus = el; }
      renderContents(parsed) {
        if (parsed && parsed.sections) renderSections(parsed.sections);
        else refreshCart();
        openCart();
      }
      open() { openCart(); }
    });
  }

  function init() {
    initHeader(document);
    defineBridge();
    initSearch();
    initCarousels(document);
    initCardSwap(document);
    tickTimers();
    setInterval(tickTimers, 1000);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", function (e) { initHeader(e.target); defineBridge(); initCarousels(e.target); initCardSwap(e.target); });

  window.WK = { openCart: openCart, openDrawer: openDrawer, refreshCart: refreshCart, addItems: addItems };
})();
